module.exports = __webpack_public_path__ + "static/img/m_role.864cfc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/sy/m_role.png
// module id = zO85
// module chunks = 7